import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminNeedsEventKeys = {
  ADMIN_NEED_ADD_BUTTON_CLICK: "admin-need-add-button-click",
  ADMIN_NEED_APPROVAL_BUTTON_CLICK: "admin-need-approval-button-click",
  ADMIN_NEED_CREATE_PAGE_VIEW: "admin-need-create-page-view",
  ADMIN_NEED_DELETE_BUTTON_CLICK: "admin-need-delete-button-click",
  ADMIN_NEED_DELETE_FAILURE: "admin-need-delete-failure",
  ADMIN_NEED_DETAIL_PAGE_VIEW: "admin-need-detail-page-view",
  ADMIN_NEED_DETAILS_EDIT_CLICK: "admin-need-details-edit-click",
  ADMIN_NEED_DETAILS_PUBLIC_LINK_CLICK: "admin-need-details-public-link-click",
  ADMIN_NEED_EDIT_BUTTON_CLICK: "admin-need-edit-button-click",
  ADMIN_NEED_EDIT_FORM_SUBMIT_ATTEMPT: "admin-need-edit-form-submit-attempt",
  ADMIN_NEED_EDIT_FORM_SUBMIT_FAILURE: "admin-need-edit-form-submit-failure",
  ADMIN_NEED_EDIT_FORM_SUBMIT_SUCCESS: "admin-need-edit-form-submit-success",
  ADMIN_NEED_EDIT_PAGE_VIEW: "admin-need-edit-page-view",
  ADMIN_NEED_EXPORT_CSV_CLICK: "admin-need-export-csv-click",
  ADMIN_NEED_EXPORT_CSV_FAILURE: "admin-need-export-csv-failure",
  ADMIN_NEED_EXPORT_CSV_SUCCESS: "admin-need-export-csv-success",
  ADMIN_NEED_FORM_SUBMIT_ATTEMPT: "admin-need-form-submit-attempt",
  ADMIN_NEED_FORM_SUBMIT_FAILURE: "admin-need-form-submit-failure",
  ADMIN_NEED_FORM_SUBMIT_SUCCESS: "admin-need-form-submit-success",
  ADMIN_NEED_PUBLIC_LINK_CLICK: "admin-need-public-link-click",
  ADMIN_NEED_SEARCH: "admin-need-search",
  ADMIN_NEED_STATUS_TOGGLE_ATTEMPT: "admin-need-status-toggle-attempt",
  ADMIN_NEED_STATUS_TOGGLE_FAILURE: "admin-need-status-toggle-failure",
  ADMIN_NEED_STATUS_TOGGLE_SUCCESS: "admin-need-status-toggle-success",
  ADMIN_NEED_TABLE_FILTER_AREA: "admin-need-filter-area",
  ADMIN_NEED_TABLE_FILTER_CATEGORY: "admin-need-table-filter-category",
  ADMIN_NEED_TABLE_FILTER_CREATED_AT: "admin-need-table-filter-created-at",
  ADMIN_NEED_TABLE_FILTER_STATUS: "admin-need-table-filter-status",
  ADMIN_NEED_TABLE_FILTER_TITLE: "admin-need-table-filter-title",
  ADMIN_NEED_TABLE_FILTER_URGENCY: "admin-need-table-filter-urgency",
  ADMIN_NEED_TABLE_SEARCH: "admin-need-table-search",
  ADMIN_NEED_VIEW_BUTTON_CLICK: "admin-need-view-button-click",
  ADMIN_NEEDS_PAGE_VIEW: "admin-needs-page-view",
  ADMIN_NEEDS_PENDING_APPROVAL_PAGE_VIEW:
    "admin-needs-pending-approval-page-view",
  ADMIN_PUBLIC_NEEDS_COPY_LINK: "admin-public-needs-copy-link",
  ADMIN_PUBLIC_NEEDS_OPEN_LINK: "admin-public-needs-open-link",
} as const;

export const AdminNeedsEventCatalog: EventCatalogFromKeys<
  typeof AdminNeedsEventKeys
> = {
  [AdminNeedsEventKeys.ADMIN_NEED_ADD_BUTTON_CLICK]: {
    description: "Admin clicked the add need button to open the new need form",
    eventType: EventType.BUTTON_CLICK,
    id: AdminNeedsEventKeys.ADMIN_NEED_ADD_BUTTON_CLICK,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_DELETE_BUTTON_CLICK]: {
    description: "Admin clicked the delete button for a need",
    eventType: EventType.BUTTON_CLICK,
    id: AdminNeedsEventKeys.ADMIN_NEED_DELETE_BUTTON_CLICK,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_DELETE_FAILURE]: {
    description: "Admin failed to delete a need",
    eventType: EventType.ERROR,
    id: AdminNeedsEventKeys.ADMIN_NEED_DELETE_FAILURE,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_EXPORT_CSV_CLICK]: {
    description: "Admin clicked export CSV for needs",
    eventType: EventType.BUTTON_CLICK,
    id: AdminNeedsEventKeys.ADMIN_NEED_EXPORT_CSV_CLICK,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_EXPORT_CSV_SUCCESS]: {
    description: "Admin successfully exported needs as CSV",
    eventType: EventType.INTERACTION,
    id: AdminNeedsEventKeys.ADMIN_NEED_EXPORT_CSV_SUCCESS,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_EXPORT_CSV_FAILURE]: {
    description: "Admin failed to export needs as CSV",
    eventType: EventType.ERROR,
    id: AdminNeedsEventKeys.ADMIN_NEED_EXPORT_CSV_FAILURE,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_EDIT_BUTTON_CLICK]: {
    description: "Admin clicked the edit button for a need",
    eventType: EventType.BUTTON_CLICK,
    id: AdminNeedsEventKeys.ADMIN_NEED_EDIT_BUTTON_CLICK,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_EDIT_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the edit need form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminNeedsEventKeys.ADMIN_NEED_EDIT_FORM_SUBMIT_ATTEMPT,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_EDIT_FORM_SUBMIT_FAILURE]: {
    description:
      "Admin failed to submit the edit need form (validation or server error)",
    eventType: EventType.ERROR,
    id: AdminNeedsEventKeys.ADMIN_NEED_EDIT_FORM_SUBMIT_FAILURE,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_EDIT_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the edit need form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminNeedsEventKeys.ADMIN_NEED_EDIT_FORM_SUBMIT_SUCCESS,
  },

  [AdminNeedsEventKeys.ADMIN_NEED_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the new need form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminNeedsEventKeys.ADMIN_NEED_FORM_SUBMIT_ATTEMPT,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_FORM_SUBMIT_FAILURE]: {
    description:
      "Admin failed to submit the new need form (validation or server error)",
    eventType: EventType.ERROR,
    id: AdminNeedsEventKeys.ADMIN_NEED_FORM_SUBMIT_FAILURE,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the new need form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminNeedsEventKeys.ADMIN_NEED_FORM_SUBMIT_SUCCESS,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_SEARCH]: {
    description: "Admin searched for a specific need",
    eventType: EventType.FILTER,
    id: AdminNeedsEventKeys.ADMIN_NEED_SEARCH,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_STATUS_TOGGLE_ATTEMPT]: {
    description: "Admin attempted to toggle the status of a need",
    eventType: EventType.INTERACTION,
    id: AdminNeedsEventKeys.ADMIN_NEED_STATUS_TOGGLE_ATTEMPT,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_STATUS_TOGGLE_FAILURE]: {
    description: "Admin failed to toggle the status of a need",
    eventType: EventType.ERROR,
    id: AdminNeedsEventKeys.ADMIN_NEED_STATUS_TOGGLE_FAILURE,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_STATUS_TOGGLE_SUCCESS]: {
    description: "Admin successfully toggled the status of a need",
    eventType: EventType.INTERACTION,
    id: AdminNeedsEventKeys.ADMIN_NEED_STATUS_TOGGLE_SUCCESS,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_VIEW_BUTTON_CLICK]: {
    description: "Admin clicked the view button for a need",
    eventType: EventType.BUTTON_CLICK,
    id: AdminNeedsEventKeys.ADMIN_NEED_VIEW_BUTTON_CLICK,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_PUBLIC_LINK_CLICK]: {
    description: "Admin clicked the public link button for a need",
    eventType: EventType.BUTTON_CLICK,
    id: AdminNeedsEventKeys.ADMIN_NEED_PUBLIC_LINK_CLICK,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_DETAILS_PUBLIC_LINK_CLICK]: {
    description:
      "Admin clicked the public link button on the need details page",
    eventType: EventType.BUTTON_CLICK,
    id: AdminNeedsEventKeys.ADMIN_NEED_DETAILS_PUBLIC_LINK_CLICK,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_DETAILS_EDIT_CLICK]: {
    description: "Admin clicked the edit button on the need details page",
    eventType: EventType.BUTTON_CLICK,
    id: AdminNeedsEventKeys.ADMIN_NEED_DETAILS_EDIT_CLICK,
  },
  [AdminNeedsEventKeys.ADMIN_NEEDS_PAGE_VIEW]: {
    description: "Admin viewed the needs management page",
    eventType: EventType.PAGE_VIEW,
    id: AdminNeedsEventKeys.ADMIN_NEEDS_PAGE_VIEW,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_CREATE_PAGE_VIEW]: {
    description: "Admin viewed the create need page",
    eventType: EventType.PAGE_VIEW,
    id: AdminNeedsEventKeys.ADMIN_NEED_CREATE_PAGE_VIEW,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_DETAIL_PAGE_VIEW]: {
    description: "Admin viewed the need detail page",
    eventType: EventType.PAGE_VIEW,
    id: AdminNeedsEventKeys.ADMIN_NEED_DETAIL_PAGE_VIEW,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_EDIT_PAGE_VIEW]: {
    description: "Admin viewed the edit need page",
    eventType: EventType.PAGE_VIEW,
    id: AdminNeedsEventKeys.ADMIN_NEED_EDIT_PAGE_VIEW,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_AREA]: {
    description: "Admin filtered needs by area",
    eventType: EventType.TABLE_FILTER,
    id: AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_AREA,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_CATEGORY]: {
    description: "Admin filtered needs by category",
    eventType: EventType.TABLE_FILTER,
    id: AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_CATEGORY,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_STATUS]: {
    description: "Admin filtered needs by status",
    eventType: EventType.TABLE_FILTER,
    id: AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_STATUS,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_CREATED_AT]: {
    description: "Admin filtered needs by created at",
    eventType: EventType.TABLE_FILTER,
    id: AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_CREATED_AT,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_TITLE]: {
    description: "Admin filtered needs by title",
    eventType: EventType.TABLE_FILTER,
    id: AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_TITLE,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_URGENCY]: {
    description: "Admin filtered needs by urgency",
    eventType: EventType.TABLE_FILTER,
    id: AdminNeedsEventKeys.ADMIN_NEED_TABLE_FILTER_URGENCY,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_TABLE_SEARCH]: {
    description: "Admin searched for a need",
    eventType: EventType.FILTER,
    id: AdminNeedsEventKeys.ADMIN_NEED_TABLE_SEARCH,
  },
  [AdminNeedsEventKeys.ADMIN_NEED_APPROVAL_BUTTON_CLICK]: {
    description: "Admin clicked the approval button for a critical need",
    eventType: EventType.BUTTON_CLICK,
    id: AdminNeedsEventKeys.ADMIN_NEED_APPROVAL_BUTTON_CLICK,
  },
  [AdminNeedsEventKeys.ADMIN_NEEDS_PENDING_APPROVAL_PAGE_VIEW]: {
    description: "Admin viewed the pending approval page",
    eventType: EventType.PAGE_VIEW,
    id: AdminNeedsEventKeys.ADMIN_NEEDS_PENDING_APPROVAL_PAGE_VIEW,
  },
  [AdminNeedsEventKeys.ADMIN_PUBLIC_NEEDS_COPY_LINK]: {
    description: "Admin copied the public needs link in PublicNeedsLinkCard",
    eventType: EventType.INTERACTION,
    id: AdminNeedsEventKeys.ADMIN_PUBLIC_NEEDS_COPY_LINK,
  },
  [AdminNeedsEventKeys.ADMIN_PUBLIC_NEEDS_OPEN_LINK]: {
    description: "Admin opened the public needs link in PublicNeedsLinkCard",
    eventType: EventType.INTERACTION,
    id: AdminNeedsEventKeys.ADMIN_PUBLIC_NEEDS_OPEN_LINK,
  },
};
